export default __webpack_public_path__ + "static/media/5.Pillar-Hydrant.42c6c570.png";